import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../../service/shared/spinner-service.service';

export const SKIP_SPINNER =  new HttpContextToken<boolean>(() => true);
 
@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
 
  private activeRequests = 0;
 
  constructor(private spinner: SpinnerService) {}
 
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.context.get(SKIP_SPINNER)) {
      return next.handle(req);
    }
 
    this.activeRequests++;
    this.spinner.show();
 
    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.spinner.hide();
        }
      })
    );
  }
}


